import axios from "@/config/axios-wrapper";
import anyAxios from "axios";

export const postAboutPageDetails = async (data) => {
  return await axios.post("/newsletter", data);
};

// starred page
export const getStarredDetails = async (id, sortVal, searchVal) => {
  return await axios.get(`/organizations/${id}/favourites`, {
    params: {
      q: searchVal,
      // skip:0,
      // limit:20,
      sort: sortVal,
    },
  });
};

// Give Star to candidates
export const giveStarredDetails = async (headers, data) => {
  return await axios.post(`/organizations/${data.organizationId}/favourites/${data.userId}`, null, {
    headers,
  });
};

// Give Star to candidates
export const giveStar = async (data) => {
  return await axios.post(`/organizations/${data.organizationId}/favourites/${data.userId}`);
};

export const deleteStarredDetails = async (id, userId, headers) => {
  return await axios.delete(`/organizations/${id}/favourites/${userId}`, {
    headers,
  });
};

// job api
export const getAllJobs = async (organizationId) => {
  return await axios.get(`/organizations/${organizationId}/jobs`);
};

export const deleteSingleJob = async (id, headers) => {
  return await axios.delete(`jobs/${id}`, headers);
};

export const postAllJobs = async (data, headers) => {
  return await axios.post("/jobs", data, headers);
};

export const postJobVedio = async (jobId, videoFile, headers) => {
  return await axios.post(`jobs/${jobId}/video`, videoFile, {
    headers,
  });
};

export const getAllSubscription = async (organizationId) => {
  return await axios.get(`/organizations/${organizationId}/subscriptions`);
};

// ----------------- [ MEETINGS API ]
// Fetch all meetings
export const getAllMeetings = async (organizationId) => {
  return await axios.get(`/organizations/${organizationId}/meetings`);
};

// Delete Meeting
export const deleteMeetingFromRedux = async (data) => {
  return await axios.delete(`/organizations/${data.organizationId}/meetings/${data.meetingsId}`);
};

// Edit Meeting
export const editMeeting = async (
  data: { organizationId: string; meetingId: string },
  updatedData: any,
) => {
  return await axios.put(
    `/organizations/${data.organizationId}/meetings/${data.meetingId}`,
    updatedData,
  );
};

// ----------------- [ CHATS API ]
export const getAllChats = async (headers, organizationId) => {
  return await axios.get(`/organizations/${organizationId}/chats`, { headers });
};

// ----------------- [ CHATS API ]
export const getAllUserNotifications = async (headers, userId, cursor = null) => {
  return await axios.get(`/users/${userId}/notifications${cursor ? `?cursor=${cursor}` : ""}`, {
    headers,
  });
};

// ----------------- [ APPLICANTS API ]
export const getTopApplicants = async (headers, jobId) => {
  return await axios.get(`/jobs/${jobId}/applications?status=new&sort=top_rated`, {
    headers,
  });
};

// ----------------- [ JOB SEEKERS API ]
export const getJobSeekers = async (data) => {
  return await axios.get(`/jobseekers?${data}`);
};

// ----------------- [ JOB SEEKERS API ]
export const postOrganizationVedio = async (organizationId, videoFile, headers) => {
  return await axios.post(`organizations/${organizationId}/video`, videoFile, {
    headers,
  });
};

export const getJobDetails = async (jobId, headers) => {
  return await axios.get(`/jobs/${jobId}`, headers);
};

export const getApplicants = async (jobId, headers) => {
  return await axios.get(
    `/jobs/${jobId}/applications?status=new&status=read&sort=top_rated`,
    headers,
  );
};

// country state city
export const getAllCountry = async () => {
  const response = await axios.get("/countries");
  return response.data;
};

export const getAllState = async (countryCode) => {
  const response = await axios.get(`/countries/${countryCode}/states`);
  return response.data;
};

export const getAllCity = async (countryCode, stateCode) => {
  const response = await axios.get(`/countries/${countryCode}/states/${stateCode}/cities`);
  return response.data;
};

// notification

export const deleteNotificationById = async (organizationId, userId, notificationId) => {
  return await axios.delete(
    `${
      organizationId ? `/organizations/${organizationId}` : `/users/${userId}`
    }/notifications/${notificationId}`,
  );
};

export const readNotifications = (userId) => {
  axios.post(`/users/${userId}/notifications/read`);
};

export const acceptOfferNotifications = (jobId, offerId) => {
  axios.post(`/jobs/${jobId}/offer/${offerId}/accept`);
};

export const declineOfferNotifications = (jobId, offerId) => {
  axios.post(`/jobs/${jobId}/offer/${offerId}/decline`);
};

export const acceptInterviewNotifications = (organizationId, meetingId) => {
  axios.post(`/organizations/${organizationId}/meetings/${meetingId}/accept`);
};

export const declineInterviewNotifications = (organizationId, meetingId) => {
  axios.post(`/organizations/${organizationId}/meetings/${meetingId}/reject`);
};

export const deleteFcmToken = async (userId) => {
  const token = localStorage.getItem("fcmToken");
  await axios.delete(`/users/${userId}/fcm-tokens/${token}`);
  localStorage.clear();
};

export const postLogOut = async (refresh_token: string) => {
  await axios.post(`/auth/logOut`, {
    refresh_token,
  });
};
// accounts

// get single user data

// ----------------- [ GET SINGLE USER DATA API ]

export const getUserData = async (userId, headers) => {
  return await axios.get(`/users/${userId}`, { headers });
};

// return axios.get(`/jobseekers${url}`, { headers });

export const updatePersonalInfo = async (userId, data, headers) => {
  return await axios.put(`/users/${userId}`, data, { headers });
};

export const updateOrganizationInfo = async (organizationId, values, headers) => {
  return await axios.put(`organizations/${organizationId}`, values, { headers });
};

export const postLoginInfo = async (data, headers) => {
  return await axios.post("/user", data, headers);
};

export const postAddressInfo = async (data, headers) => {
  return await axios.post("/users", data, headers);
};

// ----------------- [ GET SHORTLISTED CANDIDATES API ]

export const getShortlistedData = async (shortListData) => {
  return await axios.get(
    `/jobs/${shortListData.jobId}/applications?status=shortlisted&sort=${shortListData.sort}`,
  );
};

export const deleteShortlistedCandidate = async (shortListData) => {
  return await axios.post(
    `/jobs/${shortListData.jobId}/applications/${shortListData.applicationId}/delete`,
  );
};

// account api

// address

export const addressInfoUpdate = async (organizationId, values, headers) => {
  return await axios.put(`organizations/${organizationId}`, values, { headers });
};
// get organization

export const organizationData = async (organizationId, headers) => {
  return await axios.get(`/organizations/${organizationId}`, {
    headers,
  });
};

export const organizationMeetings = async (organizationId, headers) => {
  return await axios.get(`/organizations/${organizationId}/meetings`, {
    headers,
  });
};

export const deleteMeeting = async ({
  organizationId,
  meetingId,
}: {
  organizationId: string;
  meetingId: string;
}) => {
  return await axios.delete(`/organizations/${organizationId}/meetings/${meetingId}`);
};

// change email

export const updateEmail = async (userId, data, headers) => {
  return await axios.post(`/users/${userId}/change-email`, data, { headers });
};

// change password

export const updatePassword = async (userId, data, headers) => {
  return await axios.post(`/users/${userId}/change-password`, data, { headers });
};

export const getOrganizationByName = async (name) => {
  return await axios.get(`/organizations/search-names?q=${name}&limit=10`);
};

// shortlist application
export const shortlistJobApplication = async (jobId, applicationId) => {
  return await axios.post(`/jobs/${jobId}/applications/${applicationId}/shortlist`);
};

export const addToStarred = async (id, userId) => {
  return await axios.post(`/organizations/${id}/favourites/${userId}`);
};

export const sendEmailChangeOtp = async (userId, data) => {
  return await axios.post(`/users/${userId}/change-email/send-otp`, data);
};

export const verifyEmailChangeOtp = async (userId, data) => {
  return await axios.post(`/users/${userId}/change-email/verify-otp`, data);
};

export const deleteApplicant = async (jobId, appliId, headers) => {
  return await axios.post(`/jobs/${jobId}/applications/${appliId}/delete`, {}, headers);
};

export const shortlistApplicant = async (jobId, appliId, headers) => {
  return await axios.post(`/jobs/${jobId}/applications/${appliId}/shortlist`, {}, headers);
};

export const restoreApplicant = async (jobId, appliId, headers) => {
  return await axios.post(`/jobs/${jobId}/applications/${appliId}/restore`, headers);
};

export const updateOnboardingStep = async (userId, data) => {
  return await axios.put(`/users/${userId}/onboarding-step`, data);
};

export const getOnboardingStats = async (userId) => {
  return await axios.get(`/users/${userId}/onboarding-stats`);
};

export const changePassword = async (userId, data) => {
  return await axios.post(`/users/${userId}/change-password`, data);
};

// Edit Existing Job / Edit Job Details
export const editJobDetails = async (jobId, data) => {
  return await axios.put(`/jobs/${jobId}`, data);
};

export const updateUser = async (userId, data) => {
  return await axios.put(`/users/${userId}`, data);
};

export const uploadResume = async (userId, data) => {
  return await axios.post(`/users/${userId}/resume`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// creata a teammate apis and Employer Profile Apis
export const deleteResume = async (userId) => {
  return await axios.delete(`/users/${userId}/resume`);
};

export const uploadUserVideo = async (userId) => {
  return await axios.post(`/users/${userId}/video`);
};

export const deleteUserVideo = async (userId) => {
  return await axios.delete(`/users/${userId}/video`);
};

export const changeRecruiterStatus = async (userId, data) => {
  return await axios.put(`/users/${userId}/recruit-status`, data);
};

export const updateUserPhoto = async (userId) => {
  return await axios.post(`/users/${userId}/photo`);
};

export const deleteUserJobSeeker = async (userId) => {
  return await axios.delete(`/users/${userId}`);
};
// creata a teammate apis and Employer Profile Apis

export const createTeamMate = async (orgID, data) => {
  return await axios.post(`/organizations/${orgID}/teammates`, data);
};

export const updateTeamMate = async (orgID, UserID, data) => {
  return await axios.put(`/organizations/${orgID}/teammates/${UserID}`, data);
};

export const deleteTeamMate = async (orgID, userId) => {
  return await axios.delete(`/organizations/${orgID}/teammates/${userId}`);
};

export const UploadOrgLogo = async (orgID, logoFile) => {
  return await axios.post(`/organizations/${orgID}/logo`, logoFile);
};

export const UploadOrgVideo = async (orgID, videoFile) => {
  return await axios.post(`/organizations/${orgID}/video`, videoFile);
};

export const DeleteOrgVideo = async (orgID) => {
  return await axios.delete(`/organizations/${orgID}/video`);
};

export const updateUserProfleDetails = async (userID, data) => {
  return await axios.put(`/users/${userID}`, data);
};

export const checkEmailExist = async (data) => {
  return await axios.post<{ status: boolean }>("/users/email-exists", data);
};

export const getUserInformation = async (userId) => {
  return await axios.get(`/users/${userId}`);
};

export const GetOrganizationData = async (organizationId) => {
  return await axios.get(`/organizations/${organizationId}`);
};

export const UpdateOrganizationData = async (organizationId, values) => {
  return await axios.put(`organizations/${organizationId}`, values);
};

// ContactUs api

export const ContactUsAPI = async (values) => {
  return await axios.post("/contact-us", values);
};

// custom role apis

export const CreateSavedRoles = async (organizationId, data) => {
  return await axios.post(`/organizations/${organizationId}/saved-roles`, data);
};

export const GetSavedRoles = async (organizationId, data) => {
  return await axios.get(`/organizations/${organizationId}/saved-roles`, data);
};

export const UpdadeRole = async (organizationId, data, RoleId) => {
  return await axios.put(`/organizations/${organizationId}/saved-roles/${RoleId}`, data);
};

export const DeleteRole = async (organizationId, RoleId) => {
  return await axios.delete(`/organizations/${organizationId}/saved-roles/${RoleId}`);
};

// seetting api

export const getUserSettings = async (id) => {
  return await axios.get(`/users/${id}/settings`);
};

export const updateUserSettings = async (id, payload) => {
  return await axios.put(`/users/${id}/settings`, payload);
};

export const getSubscriptionDetails = async (orgID) => {
  return await axios.get(`/organizations/${orgID}/subscription`);
};

// Schedule Interview

export const getAllMeetingsTimes = async (userId) => {
  return await axios.get(`/users/${userId}/meetings`);
};

export const getCurrentMonthMeetingTime = async (data) => {
  return await axios.get(
    `/users/${data.userId}/meetings?month=${data.currentMonth}&year=${data.currentYear}&timezone=${data.currentTimeZone}`,
  );
};

export const scheduleInterview = async (organizationId, data) => {
  return await axios.post(`/organizations/${organizationId}/meetings`, data);
};

// job seeker job screen Apis

export const getJobPostData = async (queryParams) => {
  return await axios.get(`/jobs/search-2?${queryParams}`);
};

export const getCompanyName = async (query) => {
  return await axios.get(`/organizations/search-names?${query}`);
};

// job Seeker Job details Apis

export const getJobDetailsJS = async (jobId) => {
  return await axios.get(`/jobs/${jobId}`);
};

export const archieveJob = async (id, jobId) => {
  return await axios.post(`users/${id}/archived/${jobId}`);
};

// job Seeker Apply Apis

export const createApplication = async (jobId, data) => {
  return await axios.post(`/jobs/${jobId}/applications`, data);
};

export const generateUploadUrl = async (fileName) => {
  return await axios.get("/uploads/upload-presigned-url", {
    params: {
      file_name: fileName,
    },
  });
};

// job seeker side
export const getAppliedJobs = async (userId) => {
  return await axios.get(`/users/${userId}/applications?sort=new_to_old`);
};

export const applicationReview = async (jobId) => {
  return await axios.get(`applications/${jobId}`);
};

export const getArchivedJobs = async (userId) => {
  return await axios.get(`/users/${userId}/archived`);
};

export const unArchivedJob = async (userId, jobId) => {
  return await axios.delete(`/users/${userId}/archived/${jobId}`);
};

export const getInterview = async (userId) => {
  return await axios.get(`/users/${userId}/meetings`);
};

export const generatePresignedUploadUrl = async (fileName) => {
  return await axios.get(`/uploads/upload-presigned-url?file_name=${fileName}`);
};

export const cancelSubscriptions = async (orgID) => {
  return await axios.post(`organizations/${orgID}/subscription/cancel`);
};

// Delete Account
export const deleteAccount = async (id) => {
  return await axios.delete(`/users/${id}`);
};

// Upload Video for Job Post
export const uploadJobPostVideo = async (jobId, data) => {
  return await axios.post(`/jobs/${jobId}/video`, data);
};

export const getSuggestions = async (query: string) => {
  return await axios.get(`/jobs/search/autocomplete?keyword=${query}`);
};

export const getSuggestionsNew = async (query: string) => {
  return await anyAxios.get(`https://completion.go-2-work.com/v1/suggestions?q=${query}`);
};
